import { Link } from "@mui/material";
import { formatDateTimeWithSeconds } from '../../utils/DateTimeUtils';

//Common Styles
import {
  HorizontalContainer,
  SectionHeader,
  SectionTitle,
  ShowLabel,
  ShowValue,
  WorkspacePanel,
  WorkspaceSection,
  WorkSpaceTitleRow,
} from "../../styles/commonStyles";

//Icons
import { InfoIcon } from "../Svg";

//Colors
import { colors } from "../../styles/colors";

const CFPInnerDetails = ({ record }: { record: any }) => {
  return (
    <WorkspacePanel>
      <WorkspaceSection>
        <SectionHeader>
          <WorkSpaceTitleRow>
            <InfoIcon color={colors.primary} width={16} height={16} />
            <SectionTitle>Party Details</SectionTitle>
          </WorkSpaceTitleRow>
        </SectionHeader>
      </WorkspaceSection>
      <HorizontalContainer style={{ marginBottom: "8px" }}>
        <ShowLabel style={{ marginBottom: "0px" }}>createdAt:</ShowLabel>
        <ShowValue>
          {record?.createdAt
            ? formatDateTimeWithSeconds(record?.createdAt)
            : "Not Available"}
        </ShowValue>
      </HorizontalContainer>
      <HorizontalContainer style={{ marginBottom: "8px" }}>
        <ShowLabel style={{ marginBottom: "0px" }}>
          Source Of Booking:
        </ShowLabel>
        <ShowValue>
          {record?.clientId === 2
            ? "CENTAURUS"
            : record?.clientId === 4
              ? "CUSTOMER APP"
              : record?.clientId === 9
                ? "WEBSITE"
                : ""}
        </ShowValue>
      </HorizontalContainer>
      <HorizontalContainer style={{ marginBottom: "8px" }}>
        <ShowLabel style={{ marginBottom: "0px" }}>Allocator ID:</ShowLabel>
        {record?.allocatorId ? (
          <Link href={`/#/AdminUsers/${record?.allocatorId}/show`}>
            {record?.allocatorId}
          </Link>
        ) : (
          "-"
        )}
      </HorizontalContainer>
      <HorizontalContainer style={{ marginBottom: "8px" }}>
        <ShowLabel style={{ marginBottom: "0px" }}>Customer Tip:</ShowLabel>

        <ShowValue>
          {record?.vendorTipDetails[0]?.amount
            ? `${record?.vendorTipDetails[0]?.amount} (${record?.vendorTipDetails[0]?.status})`
            : "Not Available"}
        </ShowValue>
      </HorizontalContainer>
      <HorizontalContainer
        style={{
          marginBottom: "8px",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <ShowLabel style={{ marginBottom: "0px" }}>
          Reschedule Reasons:
        </ShowLabel>
        {record?.rescheduleReasons && (
          <ShowValue>{record?.rescheduleReasons || "-"}</ShowValue>
        )}
      </HorizontalContainer>
      <HorizontalContainer
        style={{
          marginBottom: "8px",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <ShowLabel style={{ marginBottom: "0px" }}>
          Reschedule Sub Reasons:
        </ShowLabel>
        {record?.rescheduleSubReason && (
          <ShowValue>{record?.rescheduleSubReason || "-"}</ShowValue>
        )}
      </HorizontalContainer>
      {record?.status === "CANCELLED" && (
        <>
          <HorizontalContainer style={{ marginBottom: "8px" }}>
            <ShowLabel style={{ marginBottom: "0px", color: "#B91C1C" }}>
              Cancelled By:
            </ShowLabel>
            {record?.cancelledBy ? (
              <Link
                href={`/#/AdminUsers/${record?.cancelledBy}/show`}
                style={{ color: "#B91C1C" }}
              >
                {record?.cancelledBy}
              </Link>
            ) : (
              <ShowValue style={{ color: "#B91C1C" }}>-</ShowValue>
            )}
          </HorizontalContainer>
          <HorizontalContainer style={{ marginBottom: "8px" }}>
            <ShowLabel style={{ marginBottom: "0px", color: "#B91C1C" }}>
              Cancelled By Type:
            </ShowLabel>
            <ShowValue style={{ color: "#B91C1C" }}>
              {record?.cancelledByType || "Not Available"}
            </ShowValue>
          </HorizontalContainer>
        </>
      )}
    </WorkspacePanel>
  );
};

export default CFPInnerDetails;
